export default __webpack_public_path__ + "static/media/rocket.8a04ea83.svg";